<template>
  <action :onAction="editPasswordAction">
    <template v-slot:icon><v-icon>lock_open</v-icon></template>
    <template v-slot:tooltip><span>Change the User's Password.</span></template>
    <template v-slot:label><span>Change Password</span></template>
  </action>
</template>

<script>
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Action from '@/components/action/Action.vue';

@Component({
  components: {
    Action,
  },
})
export default class EditPasswordAction extends Action {
  @Prop(Function) displayEditPasswordDialog;
  @Prop(Object) user;

  editPasswordAction() {
    this.displayEditPasswordDialog(this.user);
  }
}
</script>
